"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FloatingBar = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var portal_1 = require("../../hooks/portal");
var theme_1 = require("../../theme");
var card_1 = require("../card");
var fade_in_1 = require("../fade-in");
var padding_1 = require("../padding");
function FloatingBar(props) {
    var children = props.children, _a = props.offsetY, offsetY = _a === void 0 ? 0 : _a, _b = props.offsetX, offsetX = _b === void 0 ? 0 : _b, width = props.width;
    return (react_1.default.createElement(portal_1.Portal, { name: "floating-bar" },
        react_1.default.createElement(StyledFloatingBar, { offsetY: offsetY, offsetX: offsetX, width: width },
            react_1.default.createElement(fade_in_1.FadeIn, { duration: "150ms", yOffset: "".concat(16 + offsetY, "px") },
                react_1.default.createElement(card_1.Card, { style: {
                        boxShadow: "".concat(theme_1.shadows.floatingBar),
                    } },
                    react_1.default.createElement(padding_1.Padding, { x: 16, y: 8 }, children))))));
}
exports.FloatingBar = FloatingBar;
var StyledFloatingBar = styled_components_1.default.div(function (_a) {
    var offsetY = _a.offsetY, offsetX = _a.offsetX, width = _a.width;
    return ({
        width: width,
        position: 'fixed',
        zIndex: theme_1.zIndices.floating,
        left: '50%',
        bottom: 16 + offsetY,
        transform: 'translate(-50%, 0)',
        marginLeft: offsetX,
    });
});
//# sourceMappingURL=index.js.map